var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value != null)?_c('span',[_c('dt',{staticClass:"fs-14"},[_vm._v(_vm._s(_vm.label)+" : ")]),_c('dd',{staticClass:"fs-14"},[_vm._v(_vm._s(_vm.value))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }